<template>
    <!-- main container -->
    <div id="ml_app" style="width: 100%; margin-top: 20px;">

            <!-- training alert -->
            <b-alert v-if="training_mode" show variant="primary"><i class="fa-solid fa-circle-exclamation"></i>
                <span style="padding-left: 10px">Training mode is <b>enabled</b></span></b-alert>

            <!-- left pane -->
            <div id="ML_left_pane" style="float: left; width: 40%; padding-right: 30px;">

                <!-- form -->
                <div>
                    <b-form-group id="ml-input-group-2" label="Pre-Freeze Concentration:" label-for="ml-input-2">
                        <b-form-input id="ml-input-2" v-model="pre_freeze_concentration" placeholder="" required
                            :state="pre_freeze_concentration_valid"></b-form-input>
                        <b-form-invalid-feedback :state="pre_freeze_concentration_valid">
                            input required
                        </b-form-invalid-feedback>
                    </b-form-group>
                    <b-form-group id="ml-input-group-3" label="Pre-Freeze Motility (%):" label-for="ml-input-3">
                        <b-form-input id="ml-input-3" v-model="pre_freeze_motility" placeholder="" required
                            :state="pre_freeze_motility_valid"></b-form-input>
                        <b-form-invalid-feedback :state="pre_freeze_motility_valid">
                            input required
                        </b-form-invalid-feedback>
                    </b-form-group>
                    <b-form-group id="ml-input-group-3" label="Packaging:" label-for="ml-input-4">
                        <b-form-select v-model="packing" :options="packing_options"></b-form-select>
                        <b-form-invalid-feedback :state="packing_valid">
                            selection required
                        </b-form-invalid-feedback>
                    </b-form-group>
                </div>

                <!-- buttons -->
                <div style="float:left; width: 100%">
                    <div style="float: left;">
                        <b-form-checkbox v-model="training_mode" name="check-button" switch>
                            Training Mode
                        </b-form-checkbox>
                    </div>
                    <button type="button" style="float: right;" class="btn btn-primary btn-sm"
                        @click="training_predict()" :disabled="ML_processing">
                        <span v-if="ML_processing" class="spinner-border spinner-border-sm" role="status"
                            aria-hidden="true"></span>
                        Predict
                    </button>
                    <button type="button" style="float: right; margin-right: 15px;;" class="btn btn-primary btn-sm"
                        @click="random()" :disabled="ML_processing">
                        Generate Input
                    </button>
                </div>

                <!-- loading spinner -->
                <div v-if="ML_processing" style="text-align: center; margin-top: 130px;">
                    <div class="lds-facebook">
                        <div></div>
                        <div></div>
                        <div></div>
                    </div>
                    <div>processing...</div>
                </div>

                <!-- Results -->
                <div v-if="show_result" style="float:left; width: 100%; padding-top: 40px">
                    <table class="table">
                        <thead>
                            <tr>
                                <th style="width:60%">User Input</th>
                                <th style="width:40%"></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>Pre-Freeze Concentration</td>
                                <td>{{ result.pre_freeze_concentration }}</td>
                            </tr>
                            <tr>
                                <td>Pre-Freeze Motility</td>
                                <td>{{ result.pre_freeze_motility }}</td>
                            </tr>
                            <tr>
                                <td>Packaging</td>
                                <td>{{ result.packing }}</td>
                            </tr>
                        </tbody>
                    </table>

                    <table class="table">
                        <thead>
                            <tr>
                                <th style="width:60%">ML Prediction Results</th>
                                <th style="width:40%"></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>Prediction</td>
                                <td>{{ result.prediction }}</td>
                            </tr>
                            <tr>
                                <td>Confidence</td>
                                <td>{{ result.confidence }}</td>
                            </tr>
                            <tr>
                                <td>Predicted Result</td>
                                <td v-if="result.result == 'Correct'" class="text_green">{{ result.result }}</td>
                                <td v-else class="text_red">{{ result.result }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>

            </div>

            <!-- right pane -->
            <div id="ML_right_pane" style="float: left; width: 60%; padding-left: 30px;">

                <!-- history summary -->
                <div style="width: 100%; margin-top: 20px; float: left;">
                    <div style="float: left; width: 25%;">
                        <div class="summary_title">Predictions</div>
                        <div class="summary_data">{{ result.id }}</div>
                    </div>
                    <div style="float: left; width: 25%;">
                        <div class="summary_title">Correct</div>
                        <div class="summary_data" v-bind:class="{ 'text_green': correct_count > 0 }">{{
                            correct_count
                        }}</div>
                    </div>
                    <div style="float: left; width: 25%;">
                        <div class="summary_title">Incorrect</div>
                        <div class="summary_data" v-bind:class="{ 'text_red': incorrect_count > 0 }">{{
                            incorrect_count
                        }}</div>
                    </div>
                    <div style="float: left; width: 25%;">
                        <div class="summary_title">Accuracy</div>
                        <div class="summary_data">{{ accuracy }} %</div>
                    </div>
                </div>

                <!-- tabs  -->
                <div style="width: 100%; float: left;">
                    <b-tabs content-class="mt-3">
                        <b-tab title="Result history" active>
                            <!-- result history -->
                            <table class="table" style="margin-top: 30px;">
                                <thead>
                                    <tr>
                                        <th>#</th>
                                        <th>User Input</th>
                                        <th>ML Prediction Results</th>
                                        <th>Result</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="result in result_history" v-bind:key="result.id">
                                        <td>{{ result.id }}</td>
                                        <td>{{ result.pre_freeze_concentration }}, {{
                                            result.pre_freeze_motility
                                        }}, {{ result.packing }}</td>
                                        <td>{{ result.prediction }}<br /> {{ result.confidence }}</td>
                                        <td v-if="result.result == 'Correct'" class="text_green">{{
                                            result.result
                                        }}</td>
                                        <td v-else class="text_red">{{ result.result }}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </b-tab>
                        <b-tab :title="modelDataTitle">
                            <!-- model data -->
                            <table class="table" style="margin-top: 30px;">
                                <thead>
                                    <tr>
                                        <th>id</th>
                                        <th>donor</th>
                                        <th>pre_freeze_concentration</th>
                                        <th>pre_freeze_motility</th>
                                        <th>packing</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="row in modelData" v-bind:key="row.id">
                                        <td>{{ row.id }}</td>
                                        <td>{{ row.donor }}</td>
                                        <td>{{ row.pre_freeze_concentration }}</td>
                                        <td>{{ row.pre_freeze_motility }}</td>
                                        <td>{{ row.packing }}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </b-tab>
                    </b-tabs>
                </div>

            </div>

    </div>
</template>

<script>

function generateRandomWithLimit(maxLimit = 59) {
    let rand = Math.random() * maxLimit;
    console.log(rand); // say 59.81321410836433

    rand = Math.floor(rand); // 59

    return rand;
}

export default {
    name: 'ml_training',
    components: {
    },
    data: function () {
        const now = new Date()
        const today = new Date(now.getFullYear(), now.getMonth(), now.getDate())
        // Today
        const minDate = new Date(today)
        // Two days in advance
        const maxDate = new Date(today)
        maxDate.setHours(maxDate.getHours() + 48)
        return {
            pre_freeze_concentration: null,
            pre_freeze_motility: null,
            packing_options: [{ value: 0, text: 'Micro Packaging' }, { value: 1, text: 'Macro Packaging' }],
            packing: null,
            result: {
                id: 0,
                pre_freeze_concentration: null,
                pre_freeze_motility: null,
                packing: null,
                prediction: null,
                confidence: null,
                result: null,
            },
            result_history: [],
            show_result: false,
            ML_processing: false,
            pre_freeze_concentration_valid: null,
            pre_freeze_motility_valid: null,
            packing_valid: null,
            id: 0,
            correct_count: 0,
            incorrect_count: 0,
            accuracy: 0,
            training_mode: false,
            modelData: [],
            modelDataTitle: null,

            packaging_approved: false,

            section_0_expanded: true,
            section_1_expanded: true,
            section_2_expanded: true,
            section_3_expanded: true,
            section_4_expanded: true,
            moc_processing: false,
            section_0_processing: true,
            section_1_processing: true,
            section_2_processing: true,
            section_3_processing: true,
            section_4_processing: true,

            section_4_title: 'Protocol Selection',
            protocols: [],
            devices: [],
            chosenDevice: [],
            deviceData: [],
            recommended_protocol: null,
            protocol_selected: false,
            protocol_select_button_text: 'Calculating ',
            phase1_planned: false,
            phase2_planned: false,
            phase3_planned: false,
            phase4_planned: false,
            DeviceCurrentTemp: null,
            DeviceCurrentFlow: null,
            DeviceReadyTime: null,
            DeviceReadyCounter: null,

            realtimeIntervalID: null,
            deviceDataLoaded: false,
            deviceScheduled: false,

            /* Success alert */
            dismissSecs: 10,
            dismissCountDown: 0,
            scheduleCancelled: false,

            minAvailDate: minDate,
            maxAvailDate: maxDate,

            /* Sample Types */
            sampleSelected: null,
            
            sampleTypes: [// TODO: This should live in a DB
                { value: null, text: "Please choose a sample type", disabled: false },
                {
                    label: 'Human',
                    options: [
                        { value: "sperm", text: "Sperm (Human)", disabled: false },
                        { value: "wholeblood", text: "Whole Blood", disabled: true },
                        { value: "plasma", text: "Plasma", disabled: true },
                        { value: "tcell", text: "T-Cell", disabled: true },
                    ]
                },
                {
                    label: 'Aquaculture',
                    options: [
                        { value: "milt", text: "Milt (Salmon)", disabled: true },
                    ]
                }
            ],
            sampleTypeSelected: false,

            /* Form Wizard stuff */
            form_step: 1,
            form_progress: 0,

            /* Form Wizard v2 */
            wizard_steps: [
                {
                    id: 1,
                    label: '1. Sample Information',
                    active: true,
                    complete: false
                },
                {
                    id: 2,
                    label: '2. Package Selection',
                    active: false,
                    complete: false
                },
                {
                    id: 3,
                    label: '3. Protocol Selection',
                    active: false,
                    complete: false
                },
                {
                    id: 4,
                    label: '4. Machine Operating Conditions',
                    active: false,
                    complete: false
                },
                {
                    id: 5,
                    label: '5. Charts',
                    active: false,
                    complete: false
                },
                {
                    id: 6,
                    label: '6. Device Selection',
                    active: false,
                    complete: false
                },
                {
                    id: 7,
                    label: '7. Device scheduled',
                    active: false,
                    complete: false
                },
            ],
            wizard_loading: false,
            current_wizard_step: 1,
            wizard_complete: false,
            scheduleComplete: false,
        };
    },
    computed: {
        pre_freeze_concentration_validation() {
            if (this.pre_freeze_concentration == null) {
                return false;
            }
            if (this.pre_freeze_concentration.length < 1) {
                return false;
            }
            var x = Number(this.pre_freeze_concentration)
            console.log(x);
            if (Number.isFinite(x)) {
                return true;
            } else {
                return false;
            }
        },
        pre_freeze_motility_validation() {
            if (this.pre_freeze_motility == null) {
                return false;
            }
            if (this.pre_freeze_motility.length < 1) {
                return false;
            }
            var x = Number(this.pre_freeze_motility)
            console.log(x);
            if (Number.isFinite(x)) {
                return true;
            } else {
                return false;
            }
        },
    },
    props: [],
    watch: {

        DeviceReadyCounter: {
            handler(value) {
                if (value > 0) {
                    setTimeout(() => {
                        if (this.DeviceReadyCounter > 0) this.DeviceReadyCounter--;
                    }, 1000);
                }

            },
            immediate: true // This ensures the watcher is triggered upon creation
        }
    },
    beforeDestroy() {
        clearInterval(this.realtimeIntervalID);
    },
    methods: {
        countDownChanged(dismissCountDown) {
            this.dismissCountDown = dismissCountDown
        },
        showDeviceScheduledAlert() {
            this.dismissCountDown = this.dismissSecs
        },

        /* process wizard functions */
        async wizard_button(movement, action) {
                console.log("wizard_butto clicked 🤘" + movement);

                // 3 second delay
                this.wizard_loading = true;
                var delay = 0;

                if(movement == 'forward' && !this.wizard_complete) {
                    delay = 500;
                }

                // process action for step
                // -----------------------
                // step 1
                if(action == 1) {
                    await this.test_predict();
                    delay = 0;
                }
                // step 3
                if(action == 5) {
                    this.confirm_protocol_selection();
                }
                // step 6 
                if(action == 6) {
                    this.schedule_device();
                    delay = 0;
                    setTimeout(() => {
                        console.log("😜😅👋")
                        this.wizard_steps[6].complete = true;
                        this.scheduleComplete = true;
                    }, 10000);
                }

                setTimeout(() => {
                    // show loading spinner
                    this.wizard_loading = false;

                    // find current step
                    var current = null;

                    for(var i = 0; i < this.wizard_steps.length; i++) {
                        if(this.wizard_steps[i].active) {
                            current = i+1;
                        }
                    }

                    // find movement direction
                    if(movement == 'forward') {
                        this.wizard_steps[current -1].complete = true;
                        if(current < this.wizard_steps.length) {
                            current = current +1;
                        }
                    } else {
                        current = current -1;
                    }

                    console.log("current " + current);

                    this.current_wizard_step = current;

                    // flag as complete and add NFT to wallet
                    if(this.wizard_steps[this.wizard_steps.length -1].complete && !this.wizard_complete) {
                        this.wizard_complete = true;
                        console.log("WIZARD COMPLETE");
                    }

                    // move
                    if(current > 0 && current < this.wizard_steps.length +1) {
                        current = current -1;
                        for(i = 0; i < this.wizard_steps.length; i++) {
                            if(i == current) {
                                this.wizard_steps[i].active = true;
                            } else {
                                this.wizard_steps[i].active = false;
                            }
                        }
                    }

                    console.log("-----------");
                    console.log("current_wizard_step " + this.current_wizard_step);
                    console.log("wizard_complete " + this.wizard_complete);
                    console.log("-----------");

                }, delay);
        },

        /* Form wizard stuff */
        form_nextStep() {
            this.form_step++;
            this.form_progress = this.form_step * 25;
        },
        form_prevStep() {
            this.form_step--;
            this.form_progress = this.form_step * 25;
        },
        form_reset() {
            this.form_step = 1;
            this.form_progress = 0;
        },

        async test_predict() {
            this.section_0_processing = true;
            this.section_1_processing = true;
            this.section_2_processing = true;
            this.section_3_processing = true;
            this.section_4_processing = true;
            this.protocol_selected = false;
            this.phase1_planned = false;
            this.phase2_planned = false;
            this.phase3_planned = false;
            this.phase4_planned = false;
            this.section_4_title = 'Protocol Selection';
            this.protocol_select_button_text = 'Calculating ';
            this.scheduleCancelled = false;

            // input validation
            this.pre_freeze_concentration_valid = this.pre_freeze_concentration_validation
            this.pre_freeze_motility_valid = this.pre_freeze_motility_validation

            if (this.pre_freeze_concentration_valid && this.pre_freeze_motility_valid) {
                this.show_result = true;
                this.ML_processing = true;

                console.log("predict clicked!");

                var data = {
                    "endpoint": "/ml/gen",
                    "data": {
                        "pre_freeze_concentration": this.pre_freeze_concentration,
                        "pre_freeze_motility": this.pre_freeze_motility
                    }
                }

                data = JSON.stringify(data);

                console.log(data);

                let headers = {
                    'Content-Type': 'application/json;charset=utf-8',
                    'authorization': localStorage.idtoken
                };         

                try {
                    const response = await this.$http.post(
                        process.env.VUE_APP_ML_API_URI,
                        data,
                        { headers: headers }
                    );
                    this.result = response.data;

                    if (this.result.prediction == 0) {
                        this.result.prediction = "Micro Packaging"
                    } else {
                        this.result.prediction = "Macro Packaging"
                    }

                    // make confidence a percentage
                    console.log(this.result.confidence)

                    var confidenceArr = this.result.confidence.split(" ");
                    var confidence_percentage = 0;


                    if (this.result.prediction == "Micro Packaging") {
                        confidence_percentage = confidenceArr[0].substring(2);
                        this.result.confidence_percentage = (confidence_percentage * 100).toFixed(2);
                    } else {
                        confidence_percentage = confidenceArr[1].substring(0, confidenceArr[1].length - 2);
                        this.result.confidence_percentage = (confidence_percentage * 100).toFixed(2);
                    }

                    //this.show_result = true;
                    console.log(this.result);
                    this.ML_processing = false;
                    this.pre_freeze_concentration_valid = null;
                    this.pre_freeze_motility_valid = null;
                    this.form_nextStep();

                    /* Now load the Devices */
                    this.getDevices();

                    /* Now load the Protocols */
                    this.getProtocols();

                    /* Choose appropriate device */
                    this.chooseDevice()

                    // processing (mock)
                    this.moc_processing = false;
                    setTimeout(() => {
                        this.section_4_processing = false;
                        setTimeout(() => {
                            this.section_0_processing = false;
                            setTimeout(() => {
                                this.section_1_processing = false;
                                setTimeout(() => {
                                    this.section_2_processing = false;
                                    setTimeout(() => {
                                        this.section_3_processing = false;
                                        setTimeout(() => {
                                            this.phase1_planned = true;
                                            this.phase2_planned = true;
                                            this.phase3_planned = true;
                                            this.phase4_planned = true;
                                            this.protocol_select_button_text = 'Confirm ';
                                        }, 500)
                                    }, 1500)
                                }, 1500)
                            }, 1500)
                        }, 1500)
                    }, 1500)
                } catch (error) {
                    console.log(error);
                }
            }
        },
        async training_predict() {
            // input validation
            this.pre_freeze_concentration_valid = this.pre_freeze_concentration_validation
            this.pre_freeze_motility_valid = this.pre_freeze_motility_validation

            if (this.packing == null) {
                this.packing_valid = false;
            } else {
                this.packing_valid = true;
            }

            if (this.pre_freeze_concentration_valid && this.pre_freeze_motility_valid && this.packing_valid) {
                this.ML_processing = true;
                this.show_result = false;
                console.log("predict clicked!");

                var data = {
                    "endpoint": "/ml/pre",
                    "data": {
                        "pre_freeze_concentration": this.pre_freeze_concentration,
                        "pre_freeze_motility": this.pre_freeze_motility,
                        "packing": this.packing
                    }
                }

                data = JSON.stringify(data);

                console.log(data);

                let headers = {
                    'Content-Type': 'application/json;charset=utf-8',
                    'authorization': localStorage.idtoken
                };   

                try {
                    const response = await this.$http.post(
                        process.env.VUE_APP_ML_API_URI,
                        data,
                        { headers: headers }
                    );
                    this.result = response.data;

                    if (this.result.packing == 0) {
                        this.result.packing = "Micro Packaging"
                    } else {
                        this.result.packing = "Macro Packaging"
                    }

                    if (this.result.prediction == 0) {
                        this.result.prediction = "Micro Packaging"
                    } else {
                        this.result.prediction = "Macro Packaging"
                    }

                    if (this.result.result) {
                        this.result.result = "Correct"
                        this.correct_count = this.correct_count + 1;
                    } else {
                        this.result.result = "Incorrect"
                        this.incorrect_count = this.incorrect_count + 1;
                    }

                    this.id = this.id + 1;
                    this.result.id = this.id;

                    // calc accuracy
                    this.accuracy = ((this.correct_count / this.id) * 100).toFixed(2);

                    this.result_history.unshift(this.result)
                    this.show_result = true;
                    console.log(this.result);
                    this.ML_processing = false;
                    this.pre_freeze_concentration_valid = null;
                    this.pre_freeze_motility_valid = null;

                    // reset form
                    this.pre_freeze_concentration = null;
                    this.pre_freeze_motility = null;
                    this.packing = null;

                    // if traning is enabled add result to the model data
                    if (this.training_mode) {
                        console.log("Adding result to model data");

                        // set id
                        var id = this.modelData[this.modelData.length - 1].id + 1;
                        console.log(id);

                        // get latest result
                        var result = this.result;

                        // update id
                        result.id = id;

                        // add donor
                        result.donor = "USER";

                        // add updated result to data model
                        this.modelData.push(result);

                        // update tab title
                        this.modelDataTitle = "Model Data (" + this.modelData.length + " rows)";

                        // update model data
                        await this.uploadTest();
                    }

                } catch (error) {
                    console.log(error);
                }
            }
        },
        confirm_protocol_selection() {
            console.log("Confirm button clicked!");
            var me = this;
            /* Priodically refresh data (currently set to every 5 seconds) */
            this.realtimeIntervalID = window.setInterval(function () {
                /* Load data and attach to card */
                me.chooseDevice();
                me.getDeviceData();

            }, 5000)

            this.DeviceReadyCounter = ((this.DeviceReadyTime - Date.now()) / 1000)
            console.log("Device ready counter: " + this.DeviceReadyCounter)
            this.protocol_selected = true;
            this.form_nextStep();
            this.section_4_title = 'Device Selection';
        },
        random() {
            this.pre_freeze_concentration = this.genRand(0, 151, 2);
            this.pre_freeze_motility = this.genRand(1, 100, 2);
            this.packing = null;
        },
        genRand(min, max, decimalPlaces) {
            var rand = Math.random() * (max - min) + min;
            var power = Math.pow(10, decimalPlaces);
            return Math.floor(rand * power) / power;
        },
        reset() {
            console.log("history cleared");
            this.result_history = [];
            this.id = 0;
            this.correct_count = 0;
            this.incorrect_count = 0;
            this.accuracy = 0;
            this.show_result = false;
        },
        dateDisabled(ymd, date) {
            // Disable weekends (Sunday = `0`, Saturday = `6`)
            const weekday = date.getDay()
            // Return `true` if the date should be disabled
            return weekday === 0 || weekday === 6
        },
        async getModelData() {
            var data = {
                "endpoint": "/ml/modelData"
            }

            data = JSON.stringify(data);

            console.log(data);

            let headers = {
                'Content-Type': 'application/json;charset=utf-8',
                'authorization': localStorage.idtoken
            };         

            try {
                const response = await this.$http.post(
                    process.env.VUE_APP_ML_API_URI,
                    data,
                    { headers: headers }
                );

                // add id to data
                for (var i = 0; i < response.data.length; i++) {
                    response.data[i].id = i + 1;
                    if (response.data[i].packing == 0) {
                        response.data[i].packing = 'Micro Packaging'
                    } else {
                        response.data[i].packing = 'Macro Packaging'
                    }
                    this.modelDataTitle = "Model Data (" + response.data.length + " rows)";
                    console.log(response.data[i])
                }

                this.modelData = response.data;
            } catch (error) {
                console.log(error);
            }
        },
        async uploadTest() {
            console.log("uploadTest clicked!");
            var data = this.modelData;

            for (var i = 0; i < data.length; i++) {
                if (data[i].packing == 'Micro Packaging') {
                    data[i].packing = 0
                }
                if (data[i].packing == 'Macro Packaging') {
                    data[i].packing = 1
                }
            }

            data = JSON.stringify(data);

            console.log(data);

            let headers = {
                'Content-Type': 'application/json;charset=utf-8'
            };

            try {
                const response = await this.$http.post(
                    "https://3ab9-13-211-190-251.au.ngrok.io/updateModelData",
                    data,
                    { headers: headers }
                );
                console.log(response.data);
                await this.getModelData();
                return;
            } catch (error) {
                console.log(error);
                return;
            }
        },
        tab_change() {
            console.log("ML tab changed, form values cleared");
            this.pre_freeze_concentration = null;
            this.pre_freeze_motility = null;
            this.packing = null;
            this.show_result = false;
        },
        approve_packaging()
        {
            this.packaging_approved = true;
            this.form_nextStep();
        },
        clear() {
            this.form_step = 1;
            this.pre_freeze_concentration = null;
            this.pre_freeze_motility = null;
            this.packing = null;
            this.show_result = false;
            this.moc_processing = true;
            this.section_9_processing = true;
            this.section_1_processing = true;
            this.section_2_processing = true;
            this.section_3_processing = true;
            this.section_4_processing = true;

            clearInterval(this.realtimeIntervalID);
            this.scheduleCancelled = false;
        },
        expandCollapse_0() {
            if (this.section_0_expanded) {
                this.section_0_expanded = false;
            } else {
                this.section_0_expanded = true;
            }
        },
        expandCollapse_1() {
            if (this.section_1_expanded) {
                this.section_1_expanded = false;
            } else {
                this.section_1_expanded = true;
            }
        },
        expandCollapse_2() {
            if (this.section_2_expanded) {
                this.section_2_expanded = false;
            } else {
                this.section_2_expanded = true;
            }
        },
        expandCollapse_3() {
            if (this.section_3_expanded) {
                this.section_3_expanded = false;
            } else {
                this.section_3_expanded = true;
            }
        },
        expandCollapse_4() {
            if (this.section_4_expanded) {
                this.section_4_expanded = false;
            } else {
                this.section_4_expanded = true;
            }
        },
        async getProtocols() {
            /* Get Protocols */
            let url = process.env.VUE_APP_MULE_PROXY_API_URI;

            let apiheaders = {
                'Content-Type': 'application/json;charset=utf-8',
                'authorization': localStorage.idtoken
            };

            var data = {
                "endpoint": "/api/protocols"
            };

            data = JSON.stringify(data);
            console.log("Getting protocols")
            try {
                const response = await this.$http.post(
                    url,
                    data,
                    { headers: apiheaders }
                );

                this.protocols = response.data;

                console.log("Selecction: " + this.result.prediction);

                if (this.result.prediction == 'Micro Packaging') {
                    console.log("Getting MOCs")
                    data = {
                        "endpoint": "/api/mocs/" + 'sperm_micro'
                    };
                    data = JSON.stringify(data);

                    try {
                        const response = await this.$http.post(
                            url,
                            data,
                            { headers: apiheaders }
                        );
                        console.log("MOCs:")
                        console.log(response.data);
                        var moc = response.data;

                        for (var i = 0; i < this.protocols.length; i++) {
                            console.log("Protocols[i]: " + i)
                            console.log(this.protocols[i]);

                            /* Checks to see if the protocol runs within the tolerance of the Algo */
                            if (((this.protocols[i].Temperature - this.protocols[i].TempTol) <= moc[0].Cryopreservation_Temp) && ((this.protocols[i].Temperature + this.protocols[i].TempTol) >= moc[0].Cryopreservation_Temp)) {
                                /* Choose this protocol to use */
                                this.recommended_protocol = this.protocols[i];
                            }
                        }

                    }
                    catch (error) {
                        console.log(error);
                    }
                }
                /* TODO: This is a fallback and will need to be removed when the real algorithm takes over */
                else {

                    console.log("Randomly selected protocol:")
                    var rand = Math.floor(Math.random() * (5 - 1 + 1)) + 1;
                    console.log(rand)
                    // TODO: hook this up to ML model that can determine recommended protocol based on input
                    this.recommended_protocol = this.protocols[rand];
                }
                console.log(this.recommended_protocol);

            } catch (error) {
                console.log(error);
            }
        },
        async getDevices() {
            /* Get Devices */
            let url = process.env.VUE_APP_MULE_PROXY_API_URI;

            let apiheaders = {
                'Content-Type': 'application/json;charset=utf-8',
                'authorization': localStorage.idtoken
            };

            var data = {
                "endpoint": "/api/devices?active=true"
            };

            data = JSON.stringify(data);
            console.log("Getting devices")
            try {
                const response = await this.$http.post(
                    url,
                    data,
                    { headers: apiheaders }
                );

                this.devices = response.data;

                this.DeviceReadyTime = new Date(Date.now());
                this.DeviceReadyTime.setMinutes(this.DeviceReadyTime.getMinutes() + generateRandomWithLimit());
                //this.DeviceReadyTime.setHours(this.DeviceReadyTime.getHours() + 1)

            } catch (error) {
                console.log(error);
            }

        },
        async chooseDevice() {
            console.log("Choosing device")
            /* TODO: Choose the device, based on location etc. */
            for (var i = 0; i < this.devices.length; i++) {
                if (this.devices[i].Name == "Vitrafy-00006") this.chosenDevice = this.devices[i];
            }
        },
        async getDeviceData() {
            /* Get Device Data */
            let url = process.env.VUE_APP_MULE_PROXY_API_URI;

            let apiheaders = {
                'Content-Type': 'application/json;charset=utf-8',
                'authorization': localStorage.idtoken
            };

            var data = {
                "endpoint": "/api/devices/" + this.chosenDevice.Name + "/data?mode=stream"
            };

            data = JSON.stringify(data);
            console.log("Getting device data: " + data)
            try {
                const response = await this.$http.post(
                    url,
                    data,
                    { headers: apiheaders }
                );

                this.deviceData = response.data;
                console.log(this.deviceData);

                this.DeviceCurrentTemp = this.deviceData[0][0].TagValue.toFixed(1);
                this.DeviceCurrentFlow = this.deviceData[2][0].TagValue;
                this.deviceDataLoaded = true;

            } catch (error) {
                console.log(error);
            }
        },
        schedule_device() {
            this.deviceScheduled = true;
            this.showDeviceScheduledAlert();
            this.clear()
        },
        cancel_schedule() {
            this.dismissCountDown = 0;
            this.scheduleCancelled = true;
            console.log("Cancelled job")
        },
    },
    mounted: function () {
        // get model data
        this.getModelData();
    }
}
</script>

<style>
#ML_left_pane {
    float: left;
    width: 40%;
}

#ML_right_pane {
    float: left;
    width: 60%;
}

.moc_section {
    float: left;
    width: 100%;
    border-bottom: 1px solid #dee2e6;
    padding-top: 15px;
    padding-bottom: 15px;
}

.moc_section_first {
    border-top: 1px solid #dee2e6;
    /* padding-top: 0px; */
}

.moc_section span {
    font-weight: bold;
}

.chevrons {
    float: right;
    font-size: 18px;
}

.moc_sub_section {
    padding-top: 15px;
    overflow: hidden;
}

.moc_icon {
    width: 53px;
    border: 1px solid grey;
    border-radius: 50%;
    position: absolute;
    top: 10px;
    left: 0;
}

.moc_table_heading {
    /* font-weight: bold; */
    margin-bottom: 4px;
    text-transform: uppercase;
    color: #6c757d;
}

.moc_table_container {
    position: relative;
}

.moc_table {
    margin-left: 70px;
}

.moc_table td {
    width: 33.3%;
}

.moc_table th {
    /* background: #dee2e6 !important; */
    font-weight: normal;
}

.pane_heading {
    margin-bottom: 25px;
}

.summary_title {
    text-transform: uppercase;
}

.summary_data {
    font-size: 40px;
    margin-top: -10px;
    margin-bottom: 30px;
}

.text_red {
    color: red;
}

.text_green {
    color: green;
}

.invalid_select {
    border-color: #dc3545;
}

@media (max-width: 767px) {

    #ML_left_pane,
    #ML_right_pane {
        width: 100% !important;
        padding: 0 !important;
    }

    #ML_right_pane {
        margin-top: 30px;
    }

    .summary_data {
        font-size: 20px;
        font-weight: 700;
        margin-top: 0;
    }

}

.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-to {
    opacity: 0;
}

.ice {
    color: #0A58CA;
    font-size: 1.2em;
    padding-right: 5px;
}

.success {
    color: #198754;
}

.boxML {
    max-width: 75% !important;
    width: 75% !important;
    height: 200px !important;
    background-color: rgb(247, 247, 247) !important;
    margin: 5px auto;
    margin-left: 5px;
    float: left;
    position: relative;
}

.selection-boxML {
    -webkit-box-shadow: 0 3px 1px -2px rgb(0 0 0 / 20%), 0 2px 2px 0 rgb(0 0 0 / 14%), 0 1px 5px 0 rgb(0 0 0 / 12%);
    -moz-box-shadow: 0 3px 1px -2px rgb(0 0 0 / 20%), 0 2px 2px 0 rgb(0 0 0 / 14%), 0 1px 5px 0 rgb(0 0 0 / 12%);
    box-shadow: 0 3px 1px -2px rgb(0 0 0 / 20%), 0 2px 2px 0 rgb(0 0 0 / 14%), 0 1px 5px 0 rgb(0 0 0 / 12%);

    display: block;
}

.device-boxML {
    -webkit-box-shadow: 0 3px 1px -2px rgb(0 0 0 / 20%), 0 2px 2px 0 rgb(0 0 0 / 14%), 0 1px 5px 0 rgb(0 0 0 / 12%);
    -moz-box-shadow: 0 3px 1px -2px rgb(0 0 0 / 20%), 0 2px 2px 0 rgb(0 0 0 / 14%), 0 1px 5px 0 rgb(0 0 0 / 12%);
    box-shadow: 0 3px 1px -2px rgb(0 0 0 / 20%), 0 2px 2px 0 rgb(0 0 0 / 14%), 0 1px 5px 0 rgb(0 0 0 / 12%);

    display: block;
    max-width: 360px !important;
    min-width: 360px !important;
}

.device-detailsML {
    height: 140px !important;
}

.device-img {
    background-color: #68c39f !important;
    margin-right: 10px;
    float: left;
    width: 140px !important;
    height: 140px !important;
}

.device-containerML {
    display: flexbox;
    background: #FFF !important;
}

.bigTempData_MLContainer_ML {
    position: relative;
    width: 360px !important;
}

.bigTempData_MLContainer_ML i {
    position: relative;
    top: 9px;
    left: 6px;
}

.bigTempData_MLContainer_ML img {
    position: relative;
    height: 32px !important;
    top: 9px;
    left: 8px;
    float: left;
}

.bigTempData_ML {
    font-size: 32px;
    text-align: right;
    margin-right: 5%;
}

.smallTempData_ML {
    font-size: 16px;
    text-align: right;
    margin-top: -9px;
    margin-right: 5%;
}

.device-card-footer {
    background-color: #F7F7F7 !important;
    min-height: 60px !important;
    max-height: 60px !important;
    bottom: 0%;
    display: block;
    margin-left: 5%;
}

.deviceReady {
    float: left;
    margin-top: 5%;
}

.deviceSchedule {
    float: right;
}

.protocol-icon {
    padding-right: 5px;
}

#btnConfirmProtocol {
    float: right;
}


/* Form Wizard stuff */
.form-wizard {
    border: 1px solid #ccc;
    padding: 20px;
    max-width: 60%;
    margin-bottom: 20px;
}

.form-wizard-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.form-wizard-header.align-right {
    justify-content: flex-end;
}

.form-wizard-progress {
    width: 100%;
    height: 5px;
    background-color: #ddd;
    margin-top: 10px;
}

.form-wizard-progress div {
    height: 100%;
    background-color: #21ecae;
}

.form-wizard-content {
    margin-top: 20px;
    position: relative;
}

.form-wizard-reset {
    position: absolute;
    bottom: 0;
    right: 0;
    margin: 20px;
}

.form-wizard-reset button {
    background-color: #007bff;
    color: #fff;
    padding: 10px 20px;
    border: none;
    border-radius: 5px;
    cursor: pointer;
}

.form-wizard-reset button:hover {
    opacity: 0.8;
}

.form-wizard-footer {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 10px;
    margin-bottom: 10px;
}

.form-wizard-footer button {
    background-color: #d9d9d9;
    color: #000000;
    font-weight: 700;
    padding: 10px 20px;
    border-radius: 5px;
    cursor: pointer;
}

.form-back-button {
    border: none;
    border-left: 4px solid #21ecae;
}

.form-next-button {
    border: none;
    border-right: 4px solid #21ecae;
}

.form-wizard-footer button:hover {
    opacity: 0.8;
}

#sample-information-section {
    max-width: 80%;
}

    /* process wizard css */
    .process-wizard-container {
        width: 100%; 
        float: left; 
        padding: 20px; 
        padding-top: 10px;
        padding-bottom: 0;
        padding-right: 0;
        margin-bottom: 50px;
    }

    .process-wizard-steps {
        width: 25%; 
        float: left; 
        padding: 20px; 
        border-right: 1px solid #C7C8C9;
    }

    .process-wizard-step-padding {
        padding-bottom: 20px;
    }

    .process-wizard-step-icon-container {
        position: relative;
        vertical-align: top;
        font-size: 20px;
    }

    .process-wizard-step-icon {
        position: absolute;
        z-index: 1;
    }

    .process-wizard-summary-link {
        position: absolute;
        top: 7px;
        left: 9px;
        width: 3px;
        height: 100%;
        border-right: 3px solid lightgrey;
    }    

    .process-wizard-step-label {
        padding-top: 3px;
        padding-left: 34px;
    }

    .process-wizard-step-label-active {
        font-weight: 700;
    }

    .process-wizard-step-details {
        width: 75%; 
        float: left; 
        padding: 20px;
        padding-bottom: 0;
        padding-right: 0;
    }

    .process-wizard-step-details h5 {
        margin-bottom: 20px;
    }

    .process-wizard-step-step {
        min-height: 310px;
    }

    .process-wizard-footer {
        float: left;
        width: 100%;
    }

    .hideAction {
        display: none;
    }

    .subprocessCompleteButton {
        display: none;
    }    
</style>

